/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerNetsuiteDestinationComponent', [
    'DesignerBaseSourceAndDestinationComponent',

    function (DesignerBaseSourceAndDestinationComponent) {
      function DesignerNetsuiteDestinationComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.object_name = null;
        this.operation_type = null;
        this.id_field = null;
        this.batch_size = null;
        this.max_errors = null;
        this.column_mappings = [];
        this.cloud_storage_connection_id = null;
      }

      DesignerNetsuiteDestinationComponent.prototype = new DesignerBaseSourceAndDestinationComponent();

      DesignerNetsuiteDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          cloud_storage_connection_id: String(this.connection.id || ''),
          object_name: this.object_name || this.defaults.object_name,
          operation_type: this.operation_type || this.defaults.operation_type,
          id_field: this.id_field || this.defaults.id_field,
          batch_size: this.batch_size || this.defaults.batch_size,
          max_errors: this.max_errors || this.defaults.max_errors,
          column_mappings: this.column_mappings || this.defaults.column_mappings,
          database_connection_id: String(this.connection.id),
        });

        return data;
      };

      DesignerNetsuiteDestinationComponent.prototype.getFormData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getFormData.call(this);

        return data;
      };

      DesignerNetsuiteDestinationComponent.prototype.setFormData = function (data) {
        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerNetsuiteDestinationComponent.prototype.setData = function (data) {
        this.cloud_storage_connection_id = String(this.connection.id || '');
        this.object_name = data.object_name;
        this.operation_type = data.operation_type;
        this.id_field = data.id_field;
        this.batch_size = Number(data.batch_size);
        this.max_errors = Number(data.max_errors);
        this.column_mappings = data.column_mappings;
        this.cloud_storage_connection_id = data.cloud_storage_connection_id;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      DesignerNetsuiteDestinationComponent.prototype.getSchema = function () {
        const schema = DesignerBaseSourceAndDestinationComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerNetsuiteDestinationComponent;
    },
  ]);
})(window.angular);
